var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"theme-toggler"},[_c('v-btn',{attrs:{"block":"","rounded":"","width":"36","height":"36"},on:{"click":function($event){return _setup.toggleTheme()}}},[_c('fa-icon',{staticClass:"fa-lg",attrs:{"icon":_setup.icon}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }